<template>
    <div id="avaliacoes-wrapper">
        <AvaliacoesHeader :title="headerTitle" :info="showHeaderInfo" />
        <Spinner v-if="loading" />
        <router-view
            v-else
            :avaliation="avaliation"
            @update-header-info="changeHeaderInfo"
            @update-product="updateProduct"
        />
    </div>
</template>

<script>
    import AvaliacoesHeader from './AvaliacoesHeader.vue';
    import Spinner from '@bit/chicorei.chicomponents.feedback.spinner';
    import { avaliationService } from '../../../common/service/resource';

    export default {
        name: 'Avaliacoes',
        components: {
            AvaliacoesHeader,
            Spinner,
        },

        data() {
            return {
                avaliation: null,

                loading: false,
                showHeaderInfo: false,
                headerTitle: '',
            };
        },

        created() {
            this.fetchAvaliation();
        },

        methods: {
            fetchAvaliation() {
                this.loading = true;

                const orderId = this.$route.query['order'] || null;
                const token = this.$route.query['token'] || null;

                if (!orderId || !token) {
                    if (this.$route.name !== 'not-found') {
                        this.$router.push({ name: 'not-found', query: this.$route.query });
                    }
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                    return;
                }

                avaliationService
                    .getAvaliation(orderId, token)
                    .then((res) => {
                        this.avaliation = res.data;

                        if (this.$route.name !== 'home') {
                            this.$router.push({ name: 'home', query: this.$route.query });
                        }
                    })
                    .catch((err) => {
                        if (this.$route.name !== 'not-found') {
                            this.$router.push({ name: 'not-found', query: this.$route.query });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            updateProduct(productId, formData, answers) {
                let payload = new FormData();
                payload.append('note', formData.stars);
                payload.append('recommend', formData.recommend);
                if (formData.title) {
                    payload.append('title', formData.title);
                }
                if (formData.review) {
                    payload.append('review', formData.review);
                }
                payload.append('product_id', productId);
                payload.append('customer_id', this.avaliation.customer_id);

                if (formData.upload) {
                    for (let i = 0; i < formData.upload.length; i++) {
                        payload.append('customer_photo[]', formData.upload[i]);
                    }
                }

                payload.append('order_id', this.avaliation.order_id);
                payload.append('answers', JSON.stringify(answers));

                this.loading = true;
                avaliationService
                    .postProductAvaliation(
                        this.avaliation.order_id,
                        this.avaliation.order_token,
                        productId,
                        payload,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' },
                        }
                    )
                    .then(() => {
                        this.fetchAvaliation();
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },

            changeHeaderInfo(value, title) {
                this.showHeaderInfo = value;
                this.headerTitle = title;
            },
        },
    };
</script>
